import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: "1em",
	height: "1em",
	viewBox: "0 0 12 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.58984 0.78125L11.1836 5.59375C11.4297 5.86719 11.4297 6.27734 11.1562 6.52344C10.8828 6.76953 10.4727 6.76953 10.2266 6.49609L6.78125 2.85938V12.1562C6.78125 12.5391 6.48047 12.8125 6.125 12.8125C5.74219 12.8125 5.46875 12.5391 5.46875 12.1562V2.85938L1.99609 6.49609C1.75 6.76953 1.33984 6.76953 1.06641 6.52344C0.792969 6.27734 0.792969 5.83984 1.03906 5.59375L5.63281 0.78125C5.76953 0.644531 5.93359 0.5625 6.125 0.5625C6.28906 0.5625 6.45312 0.644531 6.58984 0.78125Z",
		fill: "currentColor"
	})
});
export default SvgArrow;
